import restApi from "@plannel/services/utils/rest-api";

/*
 * 개인 워크플로우는 z_p13n 에 산다(WorkflowPanel 참고) — 읽기·쓰기 모두 p13n-service 로 한다.
 * 다만 "남이 나에게 공유한 것"만은 z_p13n 을 그대로 내려줄 수 없다. 공유 범위(전원/직책) 판정을
 * 서버가 해야 하기 때문이다. 그 한 건만 전용 엔드포인트로 뺀다.
 */
const getShared = () => {
  return restApi.get("/api/workflow/shared");
}

const workflowService = {
  getShared
};

export default workflowService;
